import { BadgeCheck } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";
import { Stars } from "./Icons";
import { useLang } from "../i18n/LanguageContext";

const AVATARS = ["bg-[#FFD6CC] text-[#9A3412]", "bg-[#CCFBF1] text-[#115E59]", "bg-[#E0E7FF] text-[#3730A3]"];

export const Reviews = () => {
  const { t } = useLang();
  return (
    <section id="reviews" className="bg-[var(--paper)] py-24 sm:py-32" data-testid="reviews">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
          <SectionHead eyebrow={t.reviews.eyebrow} title={t.reviews.title} />
          <Reveal delay={0.2}>
            <div className="flex items-center gap-3 rounded-full bg-white px-4 py-2 shadow-sm ring-1 ring-black/5">
              <span className="font-display text-2xl font-extrabold text-[var(--ink)]">4.9</span>
              <Stars />
              <span className="text-xs font-medium text-slate-500">2,300+</span>
            </div>
          </Reveal>
        </div>
        <div className="mt-14 grid gap-5 md:grid-cols-3">
          {t.reviews.items.map((r, i) => (
            <Reveal key={i} delay={i * 0.1} className="min-w-0">
              <figure className="card-lift flex h-full min-w-0 flex-col rounded-[1.6rem] bg-white p-6 shadow-[0_20px_50px_-30px_rgba(11,17,32,.2)] ring-1 ring-black/5 sm:p-7" data-testid={`review-${i + 1}`}>
                <Stars />
                <blockquote className="font-display mt-5 flex-1 break-words text-lg font-medium leading-snug tracking-tight text-[var(--ink)]">“{r.text}”</blockquote>
                <figcaption className="mt-7 flex min-w-0 items-center gap-3">
                  <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full text-sm font-bold ${AVATARS[i]}`}>{r.name.split(" ").map((n) => n[0]).join("")}</span>
                  <div className="min-w-0 flex-1">
                    <p className="truncate text-sm font-semibold text-[var(--ink)]">{r.name}</p>
                    <p className="truncate text-xs text-slate-500">{r.place} · {r.trip}</p>
                  </div>
                  <span className="flex shrink-0 items-center gap-1 text-[11px] font-semibold text-emerald-600"><BadgeCheck className="h-3.5 w-3.5" />{t.reviews.verified}</span>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
